export const WHY_ONEMIND_CONSTANTS = {
  title: "Lab-as-a-Service by OneMind Cloud Services ",
  desc: [
    {
      text: "At OneMind Cloud Services, we provide a cutting-edge Lab-as-a-Service (LaaS) platform tailored for businesses, IT professionals, and educators. Our LaaS solution offers a free-build lab environment, allowing users to experiment with network setups, develop software applications, and undergo IT certification training—all without the need for costly infrastructure. ",
      highlight: [
        "OneMind Cloud Services",
        "Lab-as-a-Service (LaaS)",
        "free-build ",
        "lab environment",
      ],
    },
  ],
};
